document.addEventListener('DOMContentLoaded', () => {

  const modal = document.getElementById('productModal');
  const modalImage = document.getElementById('modalProductImage');
  const modalTitle = document.getElementById('modalProductTitle');
  const modalPrice = document.getElementById('modalProductPrice');
  const modalDesc = document.getElementById('modalProductDescription');
  const modalVariants = document.getElementById('modalVariants');
  const modalAddBtn = document.getElementById('modalAddToCart');
  const modalFeedback = document.getElementById('modalFeedback');
  let selectedVariantId = null;

  function openModal(handle) {
    const dataEl = document.querySelector('script[data-product-json="' + handle + '"]');
    if (!dataEl) return;

    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    modalImage.src = product.image;
    modalImage.alt = product.title;
    modalTitle.textContent = product.title;
    modalDesc.innerHTML = product.description;
    modalFeedback.textContent = '';
    modalFeedback.className = 'product-modal__feedback';

    modalVariants.innerHTML = '';
    if (product.variants.length > 1) {
      product.options.forEach(function (option, optIndex) {
        var group = document.createElement('div');
        group.className = 'product-modal__option-group';

        var label = document.createElement('span');
        label.className = 'product-modal__option-label';
        label.textContent = option.name;
        group.appendChild(label);

        var buttons = document.createElement('div');
        buttons.className = 'product-modal__option-buttons';

        option.values.forEach(function (value, valIndex) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'product-modal__variant-btn';
          btn.textContent = value;
          btn.dataset.optionIndex = optIndex;
          btn.dataset.value = value;
          if (valIndex === 0) btn.classList.add('is-active');
          btn.addEventListener('click', function () {
            buttons.querySelectorAll('.product-modal__variant-btn').forEach(function (b) {
              b.classList.remove('is-active');
            });
            btn.classList.add('is-active');
            updateSelectedVariant(product);
          });
          buttons.appendChild(btn);
        });

        group.appendChild(buttons);
        modalVariants.appendChild(group);
      });
    }

    updateSelectedVariant(product);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function updateSelectedVariant(product) {
    var selected = [];
    modalVariants.querySelectorAll('.product-modal__option-buttons').forEach(function (group) {
      var active = group.querySelector('.product-modal__variant-btn.is-active');
      if (active) selected.push(active.dataset.value);
    });

    var match = null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (selected.length !== v.options.length) continue;
      var isMatch = v.options.every(function (opt, idx) {
        return opt === selected[idx];
      });
      if (isMatch) { match = v; break; }
    }

    updateOptionAvailability(product, selected);

    if (!match) {
      selectedVariantId = null;
      modalPrice.textContent = '';
      modalAddBtn.disabled = true;
      modalAddBtn.textContent = 'Unavailable';
      return;
    }

    selectedVariantId = match.id;
    modalPrice.textContent = match.price;

    if (match.available) {
      modalAddBtn.disabled = false;
      modalAddBtn.textContent = 'Add to Cart';
    } else {
      modalAddBtn.disabled = true;
      modalAddBtn.textContent = 'Sold Out';
    }
  }

  function updateOptionAvailability(product, selected) {
    modalVariants.querySelectorAll('.product-modal__option-buttons').forEach(function (group, optIndex) {
      group.querySelectorAll('.product-modal__variant-btn').forEach(function (btn) {
        var hypothetical = selected.slice();
        hypothetical[optIndex] = btn.dataset.value;
        var reachable = product.variants.some(function (v) {
          return v.options.every(function (opt, idx) { return opt === hypothetical[idx]; });
        });
        btn.classList.toggle('is-unavailable', !reachable);
        btn.disabled = !reachable && !btn.classList.contains('is-active');
      });
    });
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.product-modal-trigger').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openModal(btn.dataset.productHandle);
    });
  });

  if (modal) {
    modal.querySelector('.product-modal__overlay').addEventListener('click', closeModal);
    modal.querySelector('.product-modal__close').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  if (modalAddBtn) {
    modalAddBtn.addEventListener('click', function () {
      if (!selectedVariantId || modalAddBtn.disabled) return;

      modalAddBtn.disabled = true;
      modalAddBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to add');
          return res.json();
        })
        .then(function () {
          modalFeedback.textContent = 'Added to cart! Redirecting...';
          modalFeedback.className = 'product-modal__feedback is-success';
          window.location.href = '/cart';
        })
        .catch(function () {
          modalFeedback.textContent = 'Something went wrong. Please try again.';
          modalFeedback.className = 'product-modal__feedback is-error';
          modalAddBtn.textContent = 'Add to Cart';
          modalAddBtn.disabled = false;
        });
    });
  }

  if (typeof Swiper === 'undefined') return;

  function updateNavImages(swiper) {
    const prevImg = document.querySelector('.flavour-carousel__prev .nav-can-img');
    const nextImg = document.querySelector('.flavour-carousel__next .nav-can-img');

    const slides = swiper.slides;
    const activeIndex = swiper.activeIndex;
    const totalSlides = slides.length;

    const prevIndex = (activeIndex - 1 + totalSlides) % totalSlides;
    const prevCan = slides[prevIndex]?.querySelector('.hero-can');
    if (prevImg && prevCan) {
      prevImg.src = prevCan.src;
      prevImg.alt = prevCan.alt || 'Previous';
    }

    const nextIndex = (activeIndex + 1) % totalSlides;
    const nextCan = slides[nextIndex]?.querySelector('.hero-can');
    if (nextImg && nextCan) {
      nextImg.src = nextCan.src;
      nextImg.alt = nextCan.alt || 'Next';
    }
  }

  const carousel = document.querySelector('.flavour-carousel');

  const flavourSwiper = new Swiper('.flavour-carousel', {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    speed: 800,
    loop: true,
    grabCursor: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: '.flavour-carousel__next',
      prevEl: '.flavour-carousel__prev',
    },
    breakpoints: {
      768: {
        spaceBetween: 40,
      },
    },
    on: {
      init(swiper) {
        updateNavImages(swiper);
      },
      slideChangeTransitionStart(swiper) {
        updateNavImages(swiper);

        if (typeof gsap === 'undefined') return;

        const activeSlide = swiper.slides[swiper.activeIndex];
        if (!activeSlide) return;

        const can = activeSlide.querySelector('.hero-can');
        const card = activeSlide.querySelector('.flavour-slide__card');
        const garnish = activeSlide.querySelector('.garnish-img');

        if (can) {
          gsap.fromTo(can,
            { scale: 0.8, opacity: 0, y: 40 },
            { scale: 1, opacity: 1, y: 0, duration: 0.6, ease: 'back.out(1.2)' }
          );
        }

        if (card) {
          gsap.fromTo(card,
            { x: 60, opacity: 0 },
            { x: 0, opacity: 1, duration: 0.5, delay: 0.2, ease: 'power3.out' }
          );
        }

        if (garnish) {
          gsap.fromTo(garnish,
            { scale: 0.6, opacity: 0 },
            { scale: 1, opacity: 1, duration: 0.5, delay: 0.3, ease: 'power3.out' }
          );
        }
      },
    },
  });

  if (carousel) {
    let touchStartY = 0;
    carousel.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    carousel.addEventListener('touchend', (e) => {
      const diff = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          flavourSwiper.slideNext();
        } else {
          flavourSwiper.slidePrev();
        }
      }
    });
  }
});
